import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import { Grid, List, ListItem, ListItemText, Typography } from '@material-ui/core';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { useTranslation } from 'react-i18next';

const PeriodList = ({ classes, items, selectedDay, period_hours }) => {
  const { t } = useTranslation(['booking']);

  const [list, setList] = useState(items);

  const addFour = item => {
    const [hour] = item.split(':');
    const toInt = parseInt(hour, 10) + period_hours;
    const time = `${toInt}h`;
    const moreFour = toInt < 10 ? `0${time}` : `${time}`;
    return `${hour}h - ${moreFour}`;
  };

  const formatDayAndMonth = date => {
    const [, month, day] = date.split('-');
    return `${day}/${month}:`;
  };

  const setRedirect = item => {
    selectedDay(item);
  };

  useEffect(() => {
    setList(items);
  }, [items]);

  return (
    <Grid container spacing={0} style={{ marginTop: '20px' }}>
        <Grid item xs={12}>
          <Typography variant="body2" color="secondary">
            <b>{t('mySelections')}</b>
          </Typography>
          <Typography variant="overline" style={{ textTransform: 'initial', fontWeight: 'normal' }}>
            {t('toFinishClickInFinish')}
          </Typography>
        </Grid>
        <Grid item xs={12} className={classes.content}>
          <List component="nav" style={{ padding: 0 }}>
            {list &&
              Object.entries(list)
                .filter(item => list[item[0]].length)
                .map(([key, value], index) => (
                    <ListItem
                      key={key}
                      button
                      style={
                        index !== Object.keys(list).length - 1
                          ? { borderBottom: '0.7px solid #797979' }
                          : null
                      }
                      onClick={() => setRedirect(key)}
                    >
                      <ListItemText
                        primary={
                          <Grid container spacing={0}>
                            <Grid item xs={12} style={{ display: 'flex' }}>
                              <Typography
                                variant="button"
                                style={{ fontWeight: 'bold', marginRight: '5px' }}
                                component="span"
                                color="textSecondary"
                              >
                                {formatDayAndMonth(key)}{' '}
                              </Typography>

                              <Typography variant="button" component="span" color="textSecondary">
                                {value.map((time, i) => (
                                    <div key={time} style={{ display: 'inline-block' }}>
                                      {addFour(time)}{' '}
                                      {i < value.length - 1 ? (
                                        <ArrowForwardIcon style={{ fontSize: '12px' }} />
                                      ) : (
                                        ''
                                      )}{' '}
                                    </div>
                                  ))}
                              </Typography>
                              <img
                                style={{ margin: '0 0 auto auto' }}
                                src="/images/icons/pencil.png"
                                alt=""
                              />
                            </Grid>
                          </Grid>
                        }
                      />
                    </ListItem>
                  ))}
          </List>
        </Grid>
      </Grid>
  );
};

PeriodList.propTypes = {
  classes: PropTypes.object.isRequired,
  items: PropTypes.object.isRequired,
  selectedDay: PropTypes.func.isRequired,
  period_hours: PropTypes.number.isRequired,
};

const styles = () => ({
  content: {
    border: '1px solid #797979',
    borderRadius: '4px',
    margin: '20px 0px 0px',
  },
});

export default withStyles(styles)(PeriodList);
